export default __webpack_public_path__ + "static/IDBrandGuide-747231c0f6f7d5bf119d9ca930e5a55a.pdf";